import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const FormModifier = ({ children, size, density, className, qaId }) => {
  const modifierClasses = classNames({
    [`uni-form--${size}`]: size,
    [`uni-form--${density}`]: density,
    [className]: className,
  });

  return (
    <div className={modifierClasses} data-qa-id={qaId}>
      {children}
    </div>
  );
};

FormModifier.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
  density: PropTypes.oneOf(['standard', 'compact']),
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

FormModifier.defaultProps = {
  size: 'medium',
  density: 'standard',
  className: '',
};

export default FormModifier;



// WEBPACK FOOTER //
// ./src/forms/form-modifier/index.jsx